<template>
    <div class="fullPage" ref="fullPage">
        <div ref="fullPageContainer" class="fullPageContainer"  :style="transform">
            <slot></slot>
            <!-- <div class="section section1">1</div>
            <div class="section section2">2</div>
            <div class="section section3">3</div>
            <div class="section section4">4</div>
            <div class="section section5 full-auto-height" style="height: 300px;">111111</div> -->
        </div>
        <div class="full-page-menu">
            <div :class="['full-page-menu-item', {active: (current + 1)  === item}]" v-for="(item, index) in childrenHeights.length" :key="(index + 1)" @click="toPageScollY(index)"> 0{{item}}</div>
        </div>
    </div>
</template>
<script>
import { mouseEvent } from "utils/event"
import { pageScollY, getNodeChildrenForOffsetHeight } from "utils/index";
export default {
    name: "fullPage",
    computed:{
        transform(){
            if(!this.transLateY) return "";
            return { transform: 'translate3d(0px,'+ this.transLateY +'px, 0px)'}
        }
    },
    data(){
        return {
            current: 0,
            transLateY: 0,
            childrenHeights: [],
            __resizeObserver: null,
        }
    },
    mounted(){
        this.fullPage = this.$refs.fullPage;
        this.fullPageContainer = this.$refs.fullPageContainer;
        this.fullPageHeight = this.fullPage.offsetHeight;
        this.fullPageContainerHeight = this.fullPageContainer.offsetHeight;
        this.$nextTick(() => {
            this.childrenHeights = getNodeChildrenForOffsetHeight(this.$refs['fullPageContainer']);
            // 由于异步数据/图片加载会改变高度，这里建立观察者，动态更新高度并修正位移
            if (typeof ResizeObserver !== 'undefined') {
                this.__resizeObserver = new ResizeObserver(() => {
                    this.childrenHeights = getNodeChildrenForOffsetHeight(this.$refs['fullPageContainer']);
                    this.fullPageContainerHeight = this.fullPageContainer.offsetHeight;
                    const offsetHeightCount = pageScollY(this.childrenHeights, this.current);
                    this.transLateY = -offsetHeightCount;
                });
                this.__resizeObserver.observe(this.fullPageContainer);
            }
            // 兜底：窗口尺寸变化时也重新计算
            this.__onResize = () => {
                this.fullPageHeight = this.fullPage.offsetHeight;
                this.childrenHeights = getNodeChildrenForOffsetHeight(this.$refs['fullPageContainer']);
                const offsetHeightCount = pageScollY(this.childrenHeights, this.current);
                this.transLateY = -offsetHeightCount;
            };
            window.addEventListener('resize', this.__onResize);
        })
        mouseEvent({
            target: this.fullPageContainer,
            // delta > 0 表示向下滚动，delta < 0 表示向上滚动
            callback: (e, delta) => {
                if(delta > 0){
                    // 向下滚：切换到下一屏
                    if(this.current >= (this.childrenHeights.length -1)) return;
                    this.current += 1;
                }else{
                    // 向上滚：回到上一屏
                    if(this.current === 0) return;
                    this.current -= 1;
                }
                let offsetHeightCount = pageScollY(this.childrenHeights, this.current)
                this.transLateY = -offsetHeightCount;
            }
        });
    },
    beforeDestroy(){
        if(this.__resizeObserver){
            try{ this.__resizeObserver.disconnect(); }catch(e){}
            this.__resizeObserver = null;
        }
        if(this.__onResize){
            window.removeEventListener('resize', this.__onResize);
            this.__onResize = null;
        }
    },
    methods:{
        toPageScollY(val){
            if(val === this.current) return false;
            if(val > this.current){
                this.current = val + 1;
            }else{
                this.current = val - 1;
            }
            this.current = val;
            let offsetHeightCount = pageScollY(this.childrenHeights, this.current)
            this.transLateY = -offsetHeightCount;
        }
    }
}
</script>
<style lang="less" scoped>
.fullPage{
    height: 100vh;
    overflow: hidden;
    .fullPageContainer{
        touch-action: none;
        transition: all 700ms ease 0s;
    }
    .full-page-menu{
        position: fixed;
        bottom: 60px;
        z-index: 99;
        .full-page-menu-item{
            position: relative;
            font-size: 16px;
            color: #333333;
            cursor: pointer;
            .flex(center, center);
            &::before{
                content: "";
                display: inline-block;
                width: 80px;
                height: 2px;
                margin-right: 5px;
                background-color: transparent;
                transition: all .3s;
            }
        }
        .full-page-menu-item.active{
             &::before{
                background-color: @brand;
                width: 100px;
             }
        }
    }
}
// .section{
//     height: 100vh;
//     background-color: antiquewhite;
//     color: #333;
//     text-align: center;
// }
// .section2{
//     background-color: aquamarine;
//     color: #333;
// }
// .section3{
//     background-color: rgb(221, 71, 12);
//     color: #fff;
// }
// .section4{
//     background-color: rgb(90, 74, 235);
//     color: #fff;
// }
// .section5{
//     background-color: rgb(28, 109, 91);
//     color: #fff;
// }
</style>